// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1gPQA","container":"styles_container__YE2LK","title":"styles_title__1JByk","wrapper":"styles_wrapper__1Am8p","answer":"styles_answer__2VzHx"};